import React from "react";
import XGSFormTextarea from "ui-components/form/textarea/xgsFormTextarea";

export default function DrivingInstructions(): JSX.Element {

    return (
        <>
            <XGSFormTextarea
                name="drivingInstructions"
                label=""
                required={false}
            />
        </>
    );
}

